import api from './api';

const ClassroomService = {
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/classrooms/', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`/classrooms/${id}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await api.post('/classrooms/', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`/classrooms/${id}/`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  partialUpdate: async (id, data) => {
    try {
      const response = await api.patch(`/classrooms/${id}/`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`/classrooms/${id}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default ClassroomService;
